import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { Button, ButtonGroup, useToast } from '@chakra-ui/react'
import { graphql } from '@/__generated__/gql'
import { useViewer } from '@/components/viewer-context-provider'
import { Drawer } from '@/components/drawer'
import { SupplierForm, FormValues } from './components/supplier-form'

const createSupplierDocument = graphql(`
  mutation CreateSupplier($input: SupplierInput!) {
    createSupplier(input: $input) {
      message
      supplier {
        id
      }
    }
  }
`)

export function NewSupplierRoute() {
  const viewer = useViewer()
  const navigate = useNavigate()
  const toast = useToast()
  const onClose = useCallback(() => navigate('..'), [navigate])

  const [createSupplier, { loading: isSubmitting }] = useMutation(
    createSupplierDocument,
    {
      refetchQueries: ['Suppliers'],
      onCompleted(data) {
        toast({
          status: 'success',
          title: data.createSupplier.message,
          isClosable: true,
        })
        navigate(`../${data.createSupplier.supplier.id}`)
      },
      onError(error) {
        toast({
          status: 'error',
          title: error.message,
          isClosable: true,
        })
      },
    }
  )

  const onSubmit = async (input: FormValues) => {
    await createSupplier({ variables: { input } })
  }

  return (
    <Drawer
      title="Ny leverandør"
      onClose={onClose}
      size="lg"
      footer={
        <ButtonGroup>
          <Button onClick={onClose}>Avbryt</Button>
          <Button
            form="supplier-form"
            type="submit"
            colorScheme="blue"
            isLoading={isSubmitting}
          >
            Opprett leverandør
          </Button>
        </ButtonGroup>
      }
    >
      <SupplierForm
        onSubmit={onSubmit}
        defaultValues={{ userId: viewer.user?.id }}
      />
    </Drawer>
  )
}
